module.exports = __webpack_public_path__ + "static/media/shaff1154.554f5f92.jpg";